module.exports = __webpack_public_path__ + "static/phoneframe-4f0102b3eda10841b615cc498d33bb82.png";